/**
 * Maison Confettis — brandage Judge.me sur fiche produit
 * (contourne le cache HTML Shopify en transformant le widget déjà présent)
 */
(function () {
  var BRAND = {
    '--jdgm-primary-color': '#89766d',
    '--jdgm-secondary-color': 'rgba(137, 118, 109, 0.12)',
    '--jdgm-star-color': '#89766d',
    '--jdgm-write-review-text-color': '#faf3ec',
    '--jdgm-write-review-bg-color': '#89766d',
    '--jdgm-paginate-color': '#89766d',
    '--jdgm-border-radius': '0.95rem',
    '--jdgm-reviewer-name-color': '#3d2f2a',
  };

  function applyColors(root) {
    var html = document.documentElement;
    Object.keys(BRAND).forEach(function (key) {
      html.style.setProperty(key, BRAND[key], 'important');
      if (root) root.style.setProperty(key, BRAND[key], 'important');
    });

    (root || document).querySelectorAll('.jdgm-star, .jdgm-star.jdgm--on, .jdgm-star.jdgm--half').forEach(function (el) {
      el.style.setProperty('color', '#89766d', 'important');
    });
    (root || document).querySelectorAll('.jdgm-histogram__bar-content').forEach(function (el) {
      el.style.setProperty('background-color', '#fed497', 'important');
    });
    (root || document)
      .querySelectorAll('.jdgm-write-rev-link, .jdgm-btn--solid, .jdgm-submit-rev, input.jdgm-submit-rev')
      .forEach(function (el) {
        el.style.setProperty('background', '#89766d', 'important');
        el.style.setProperty('background-color', '#89766d', 'important');
        el.style.setProperty('color', '#faf3ec', 'important');
        el.style.setProperty('border-radius', '0.95rem', 'important');
        el.style.setProperty('font-family', 'Montserrat, sans-serif', 'important');
        el.style.setProperty('text-transform', 'uppercase', 'important');
        el.style.setProperty('letter-spacing', '0.1em', 'important');
      });
    (root || document).querySelectorAll('.jdgm-rev__buyer-badge').forEach(function (el) {
      el.style.setProperty('background-color', '#89766d', 'important');
      el.style.setProperty('color', '#faf3ec', 'important');
    });
  }

  function countReviews(root) {
    var nodes = root.querySelectorAll('.jdgm-rev');
    if (nodes.length) return nodes.length;
    var summary = root.querySelector('[data-number-of-reviews], .jdgm-rev-widg__summary');
    if (!summary) return 0;
    var match = String(
      summary.getAttribute('data-number-of-reviews') || summary.textContent || ''
    ).match(/\d+/);
    return match ? parseInt(match[0], 10) || 0 : 0;
  }

  function ensureHeader(section, root) {
    var existing = section.querySelector('[data-mcp-reviews-header]');
    if (!existing) {
      existing = document.createElement('header');
      existing.className = 'mcp-pdp-reviews__header';
      existing.setAttribute('data-mcp-reviews-header', 'true');
      existing.innerHTML =
        '<h2 class="mcp-pdp-reviews__title" data-mcp-reviews-title></h2>' +
        '<p class="mcp-pdp-reviews__subtitle" data-mcp-reviews-subtitle></p>';
      var inner = section.querySelector('.section, .layout-panel-flex, .spacing-style') || section;
      inner.insertBefore(existing, inner.firstChild);
    }

    var has = countReviews(root) > 0;
    var title = existing.querySelector('[data-mcp-reviews-title]');
    var subtitle = existing.querySelector('[data-mcp-reviews-subtitle]');
    if (title) title.textContent = has ? 'Ils ont adoré' : 'Soyez le premier à adorer';
    if (subtitle) {
      subtitle.textContent = has
        ? 'Avis vérifiés de parents'
        : 'Partagez votre expérience de fête';
    }

    // Masquer le titre natif Judge.me
    root.querySelectorAll('.jdgm-rev-widg__title, .jdgm-rev-widg__summary-text').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function ensureConfetti(section) {
    if (section.querySelector('.mcp-confetti-bg')) return;
    section.classList.add('mcp-pdp-reviews');
    section.style.position = 'relative';
    section.style.isolation = 'isolate';
    section.style.overflow = 'hidden';
    section.style.background = '#faf3ec';
    section.style.paddingBlock = 'clamp(2.5rem, 6vw, 4.25rem)';

    var confetti = document.createElement('div');
    confetti.className = 'mcp-confetti-bg force-full-width mcp-confetti-bg--soft';
    confetti.setAttribute('aria-hidden', 'true');
    // Réutilise le fond déjà chargé ailleurs si possible
    var existingBg = document.querySelector('.mcp-confetti-bg');
    if (existingBg && existingBg.style.getPropertyValue('--mcp-confetti-bg')) {
      confetti.style.setProperty(
        '--mcp-confetti-bg',
        existingBg.style.getPropertyValue('--mcp-confetti-bg')
      );
    } else {
      var link = document.querySelector('link[href*="mcp-confettis-bg"], img[src*="mcp-confettis-bg"]');
      // fallback cream pattern via CSS asset path convention
      confetti.style.setProperty(
        '--mcp-confetti-bg',
        'url(/cdn/shop/t/4/assets/mcp-confettis-bg.jpg)'
      );
    }
    section.insertBefore(confetti, section.firstChild);
  }

  function enhance() {
    var widget =
      document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg');
    if (!widget) return false;

    var section = widget.closest('.shopify-section') || widget.parentElement;
    if (!section) return false;

    section.classList.add('mcp-pdp-reviews');
    ensureConfetti(section);
    ensureHeader(section, widget.closest('.jdgm-widget, .jdgm-rev-widg') || widget);
    applyColors(section);
    return true;
  }

  function boot() {
    enhance();
    var n = 0;
    var timer = setInterval(function () {
      enhance();
      if (++n > 60) clearInterval(timer);
    }, 250);
    document.addEventListener('judgeme:loaded', enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
